/* generated by pull.js */
const manifest = {
  "name": "Customizable editor menu bar",
  "description": "Allows you to hide specific editor menu bar items or remove their labels or icons.",
  "credits": [
    {
      "name": "philipp2007"
    },
    {
      "name": "CST1229",
      "link": "https://scratch.mit.edu/users/CST1229/"
    },
    {
      "name": "lisa_wolfgang",
      "link": "https://scratch.mit.edu/users/lisa_wolfgang/"
    }
  ],
  "info": [
    {
      "type": "notice",
      "id": "small-screens",
      "text": "The text labels may be automatically replaced by icons on smaller windows."
    }
  ],
  "tags": [],
  "settings": [
    {
      "dynamic": true,
      "name": "Show menu...",
      "id": "menu-labels",
      "type": "select",
      "potentialValues": [
        {
          "name": "Icons and labels",
          "id": "both"
        },
        {
          "name": "Icons only",
          "id": "icons"
        },
        {
          "name": "Labels only",
          "id": "labels"
        }
      ],
      "default": "both"
    }
  ],
  "userstyles": [
    {
      "url": "menu-icons.css",
      "if": {
        "settings": {
          "menu-labels": "icons"
        }
      }
    },
    {
      "url": "menu-labels.css",
      "if": {
        "settings": {
          "menu-labels": "labels"
        }
      }
    }
  ],
  "dynamicDisable": false,
  "enabledByDefault": true
};
export default manifest;
